export default function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/es/isSafeClassName.js
// module id = 828
// module chunks = 1